import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

/* images */
import riceImg from "../../images/rice.png";
import meatImg from "../../images/meal.png";
import dailyImg from "../../images/Daily_Essentials.png";

const PromoStrip = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
const isArabic = i18n.language === "ar";

  /* ✅ ALL BANNERS */
  const banners = [
    {
      title: "promo_bulk_rice_offers",
      desc: "promo_up_to_20_off",
      cta: "promo_view_products",
      category: "Rice",
      theme: "rice",
      image: riceImg,
    },
    {
      title: "promo_meat_deals",
      desc: "promo_fresh_frozen",
      cta: "promo_view_products",
      category: "Meat",
      theme: "meat",
      image: meatImg,
    },
    {
      title: "promo_daily_essentials",
      desc: "promo_best_prices",
      cta: "promo_view_products",
      category: "Daily",
      theme: "daily",
      image: dailyImg,
    },
  ];

  const [visibleBanners, setVisibleBanners] = useState([]);

  /* 🔀 RANDOM PICK FUNCTION */
  const getRandomBanners = () => {
    const shuffled = [...banners].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 3);
  };

  /* ================= INITIAL LOAD ================= */
  useEffect(() => {
    setVisibleBanners(getRandomBanners());
  }, []);

  /* ================= AUTO CHANGE EVERY 6 HOURS ================= */
  useEffect(() => {
    const interval = setInterval(() => {
      setVisibleBanners(getRandomBanners());
    }, 6 * 60 * 60 * 1000); // ✅ 6 hours

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="container mt-5" dir={isArabic ? "rtl" : "ltr"}>
      <section className="mm-promo-strip">

        {visibleBanners.map((c, i) => (
          <div
            className={`mm-promo-card mm-theme-${c.theme}`}
            key={i}
          >
            {/* glow */}
            <span className="mm-promo-glow" />

            {/* LEFT CONTENT */}
            <div className="mm-promo-content">
            <h4>{t(c.title)}</h4>
            <p>{t(c.desc)}</p>

              {/* ✅ CATEGORY FILTER */}
              <button
                onClick={() =>
                  navigate(
                    `/categorieList?category=${encodeURIComponent(
                      c.category
                    )}`
                  )
                }
              >
                {t(c.cta)}
              </button>
            </div>

            {/* RIGHT IMAGE */}
            <div className="mm-promo-media">
              <img src={c.image} alt={t(c.title)} />
            </div>
          </div>
        ))}

      </section>
    </div>
  );
};

export default PromoStrip;